<template>
  <div class="skeleton" :class="{ 'skeleton-loading': loading }">
    <v-skeleton-loader
      ref="skeleton"
      type="image, table-heading"
      class="videoStream_skeleton videoStream_skeleton-1"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'VideoStreamSkeleton',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: mapState({
    common: (state) => state.common,
  }),
};
</script>

<style lang="scss">
.videoStream_skeleton {
  &_wrapper {
    .skeleton {
      @media (min-width: 1280px) {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  &-1 {
    margin-bottom: 34px;
    @media (min-width: 1280px) {
      width: calc(100% - 12px);
      margin-bottom: 0;
    }
    .v-skeleton-loader__image {
      width: 100%;
      min-height: 215px;
      max-height: 542.89px;
      height: calc(56.25vw - 271.69px);
      border-radius: 0;
      @media (min-width: 1280px) {
        height: calc(38.25vw - 191px);
        max-height: 302.89px;
      }
    }
    .v-skeleton-loader__table-heading {
      padding: 7px 0;
    }
    .v-skeleton-loader__heading {
      border-radius: 8px;
      height: 16px;
      width: 120px;
      max-width: 20%;
      flex-grow: 0;
    }
    .v-skeleton-loader__text {
      width: 380px;
      max-width: 70%;
      margin: 0;
      flex-grow: 0;
    }
  }
  &-2 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    @media (min-width: 1280px) {
      flex-direction: column;
      margin: 0;
      width: calc(32% - 18px);
      justify-content: flex-start;
      /*.videoStream_details {
        margin-bottom: calc(2vw - 25px);
      }*/
    }
    .v-skeleton-loader__image {
      width: calc(50% - 15px);
      min-height: 99px;
      max-height: 248.52px;
      height: calc(28.13vw - 144.33px);
      border-radius: 0;
      @media (min-width: 1280px) {
        width: 100%;
        height: calc(18vw - 97.08px);
      }
    }
    > .v-skeleton-loader__text {
      display: none;
      @media (min-width: 1280px) {
        display: block;
        border-radius: 8px;
        height: 16px;
        width: 120px;
        flex-grow: 0;
        margin-top: 7px;
        &:nth-child(2) {
          margin-bottom: calc(2vw - 17px);
        }
      }
    }
    .v-skeleton-loader__sentences {
      width: 100%;
      display: flex;
      padding: 7px 0;
      .v-skeleton-loader__text {
        border-radius: 8px;
        height: 16px;
        width: 120px;
        flex-grow: 0;
        &:first-child {
          margin-right: calc(50% - 105px);
        }
      }
    }
  }
}
</style>
